export default __webpack_public_path__ + "static/media/follow-couse.8ce8e689.svg";